<template>
    <div class="cont-com">
        <el-row :gutter="10">
            <el-col :sm="12" :offset="0" v-for="(com,index) in capa.comisiones" :key="com.id"
                v-if="com.publicacion == 1">
                <div class="comisiones">
                    <h3>Comisión {{ com.id }}

                        <el-button type="primary" style="float:right" size="mini" @click="masdetalles(com.id)"
                            icon="el-icon-plus">
                            {{ tienePre(com) ? 'Ver preinscripciones' : 'Ver inscripciones' }}
                            </el-button>

                    </h3>
                    <table class="table table-bordered table-com">
                        <tr>
                            <td>Estado</td>
                            <th>

                                <el-button v-if="setBoton(com, index).type && ![10,11,12].includes(com.inscripcion)" :class="setBoton(com,index).class"
                                    :type="setBoton(com, index).type" size="mini" @click.stop="inscribir(com)"> {{
                                    setBoton(com, index).text}}</el-button>
                                <el-button @click="inscribirOtroCuil(com)"
                                    v-if="com.publicacion && com.inscripcion == 10 && com.fecha_ins" type="warning"
                                    size="mini">
                                    INSCRIPTO EL {{ com.fecha_ins }} </el-button>
                                <el-button @click="inscribirOtroCuil(com)"
                                    v-if="com.publicacion && com.inscripcion == 11" type="warning" size="mini">
                                    VERIFICAR DESTINATARIOS </el-button>

                                <el-button @click="inscribirOtroCuil(com)"
                                    v-if="com.publicacion && com.inscripcion == 12" type="warning" size="mini">
                                    {{com.msjTitle }}</el-button>

                            </th>
                        </tr>
                        <tr>
                            <td>Fecha inicio</td>
                            <th>{{ com.fecha_inicio | moment('DD/MM/YYYY') }}</th>
                        </tr>
                        <tr>
                            <td>Fecha fin</td>
                            <th>{{ com.fecha_fin | moment('DD/MM/YYYY') }}</th>
                        </tr>
                        <tr>
                            <td style="height:80px">Lugar</td>
                            <th style="height:80px">{{ com.lugar + ' - ' + com.direccion }}</th>
                        </tr>
                        <tr>
                            <td>Encuentros</td>
                            <th>{{ com.cantidad_encuentros }}</th>
                        </tr>
                        <tr v-if="tienePre(com)">
                            <td colspan="2" class="td-pre">
                                Preinscripciones
                                <small style="float:right; padding-top:2px">COM#{{ com.id }}</small>

                            </td>
                        </tr>
                        <tr>
                            <td class="cupos">Cupo Real</td>
                            <th class="cupos">{{ com.cupo }}</th>
                        </tr>
                        <tr v-if="tienePre(com)">
                            <td class="cupos">Cupo Preinscripción</td>
                            <th class="cupos">{{ com.cupo_preinscripcion }}</th>
                        </tr>
                        <tr v-if="tienePre(com)">
                            <td class="cupos">Inicio Preinscripción</td>
                            <th class="cupos">{{ com.fecha_apertura_preinscripcion | moment('DD/MM/YYYY [a las] HH:mm [hs]') }}</th>
                        </tr>

                        <tr v-if="tienePre(com)">
                            <td class="cupos">Cierre Preinscripción</td>
                            <th class="cupos">{{ com.fecha_cierre_preinscripcion | moment('DD/MM/YYYY [a las] HH:mm [hs]') }}</th>
                        </tr>
                    </table>
                    <!-- <div class="table-p"  v-html="com.cronograma"></div> -->
                </div>

            </el-col>

        </el-row>
        <InscribirDocente></InscribirDocente>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus'
import InscribirDocente from "@/components/capacitacion/inscripcionForm"
    export default {
        props:['capa'],
        components:{InscribirDocente},
        data() {
            return {
                habilitaForm: 0
            }
        },
        methods: {
          
            tienePre(com) {

                return com.cupo_preinscripcion && com.fecha_apertura_preinscripcion &&  com.fecha_cierre_preinscripcion
            },
            setBoton(com, index)
            {
                 console.log(com)

                // Validar si los campos de fecha y cupo existen, y si hoy está entre las fechas de apertura y cierre
             
                var boton = {
                    type:'',
                    text:'',
                    click:''
                }
                
                if (com.isActiveComision)
                {
                    if (com.isActivePre)
                    {
                            this.capa.comisiones[index].tienePre = 1
                            this.capa.comisiones[index].habilitaForm = 1
                            this.capa.comisiones[index].nombreCapa = this.capa.capa.nombre
                            boton = {
                                class: 'btn-abiertas',
                                type: 'success',
                                text: 'Preinscipciones Abiertas',

                            }
                    }
                    else{
                        if(com.tienePre)
                        {
                            this.capa.comisiones[index].habilitaForm = 0

                            boton = {
                                class: '',
                                type: 'info',
                                text: 'Preinscripciones Cerradas',

                            }
                        }
                        else{
                            if (com.cupo_disponible > 0)
                            {
                                    this.capa.comisiones[index].tienePre = 1
                                    this.capa.comisiones[index].habilitaForm = 1
                                    this.capa.comisiones[index].nombreCapa = this.capa.capa.nombre
                                    boton = {
                                        class: 'btn-abiertas',
                                        type: 'success',
                                        text: 'Preinscipciones Abiertas',

                                    }
                            }else{
                                this.capa.comisiones[index].habilitaForm = 0

                                boton = {
                                    class: '',
                                    type: 'info',
                                    text: 'Inscripciones Cerradas',

                                }
                            }
                        }
                    }
                   
                }
                else{
                    
                  
                        this.capa.comisiones[index].habilitaForm = 0

                        boton = {
                            class: '',
                            type: 'danger',
                            text: 'Inscripciones Cerradas',

                        }
                   
                   
                        
                    
                }
               
                   
                

                return boton
            },
          
            inscribir(com) {
console.log(com.habilitaForm);
                if (com.habilitaForm){

                    EventBus.$emit('verinscribir', com)
                }

         
            },
            inscribirOtroCuil(comision) {
                console.log(comision)

                this.$alert(comision.msj + '<br><small style="color:red ">Para inscribir otro cuil, refresque la pagina</small>', comision.msjTitle + ' -  CUIL:' + comision.cuil, {
                    confirmButtonText: 'ACEPTAR',
                    type: 'info',
                    dangerouslyUseHTMLString: true,
                    callback: () => {
                        // this.buscarCapa(this.$route.params.token, this.$route.params.slug)

                    }
                })},
            masdetalles(id)
            {

                this.$router.push({
  name: 'detalleCom',
  params: { ...this.$route.params, com: id }, // Mantén los otros parámetros y cambia solo `id`
  
});
            }
        },
    }
</script>

<style lang="scss" scoped>

.cont-com{
    margin-bottom: 10px;
}
.comisiones h3{
    padding:10px 8px;
    border-bottom: 1px solid #d5d5d5;
    background: #f1f1f1;

}
.comisiones{
  padding:0px;
  border: 1px solid #d5d5d5;
  margin-top: 10px;
}
.comisiones table{
    margin:0
}
.comisiones table > tr > td, .comisiones table>tr>th{
    font-size: 14px;
}
.td-pre{
    background: #9E9E9E;
    color: white;
    font-size: 18px !important;
}

.cupos {
  background-color: #FFFDE7;
}

tr:nth-child(odd) .cupos {
  background-color: #e0e0e0;
}

.btn-abiertas {

    font-family: 'Roboto', sans-serif;
    background: #4CAF50 url(@/assets/base2.png) !important;
    border-color: #4CAF50 ;
    /* Cambio clave: Ancho completo para el botón */
}
.el-button--default {
    text-transform: uppercase;
    font-family: 'Roboto', sans-serif;
    background: #FFF url(@/assets/base2.png) !important;
    border-color: #FFF;
    width: 100%;
    
}
.el-button--success {
    text-transform: uppercase;
font-family: 'Roboto', sans-serif;
    background: #4CAF50 url(@/assets/base2.png) !important;
    border-color: #4CAF50;
    width: 100%;
}
.el-button--danger {
    text-transform: uppercase;
    background: #800322ce url(@/assets/base2.png) !important;
    border-color: #800322ce !important;
    width: 100%;
}

.el-button--warning {
    text-transform: uppercase;
    background: #FFA726  url(@/assets/base2.png) !important;
    border-color: #FFA726  !important;
    width: 100%;
}

.el-button--info {
    text-transform: uppercase;
    background: #706d6ece url(@/assets/base2.png) !important;
    border-color: #706d6ece !important;
    width: 100%;
}

@media screen and (max-width:768px) {
    .comisiones{

  margin-top: 0px;
  border-top: 20px solid #ffc60a;
}
    .comisiones h3{
    padding:10px 20px;
    padding-right: 8px;
   

}
.comisiones table > tr > td{
    padding-left: 20px;
}
}
</style>